"use strict";

var _slicedToArray = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrayDataType = void 0;

var _ = require("lodash");

var set_1 = require("../abstract_data_types/types/set");

var constants_1 = require("../utils/constants");

var ArrayDataType = /*#__PURE__*/function (_set_1$AbstractSetDat) {
  _inherits(ArrayDataType, _set_1$AbstractSetDat);

  var _super = _createSuper(ArrayDataType);

  function ArrayDataType(dataItem, dataTypeFactory) {
    var _this;

    _classCallCheck(this, ArrayDataType);

    // Construct parent
    var isArray = true;

    var _ArrayDataType$_decod = ArrayDataType._decodeElementTypeAndLengthFromType(dataItem.type),
        _ArrayDataType$_decod2 = _slicedToArray(_ArrayDataType$_decod, 2),
        arrayElementType = _ArrayDataType$_decod2[0],
        arrayLength = _ArrayDataType$_decod2[1];

    _this = _super.call(this, dataItem, dataTypeFactory, isArray, arrayLength, arrayElementType); // Set array properties

    _this._elementType = arrayElementType;
    return _this;
  }

  _createClass(ArrayDataType, [{
    key: "getSignatureType",
    value: function getSignatureType() {
      return this._computeSignature(false);
    }
  }, {
    key: "getSignature",
    value: function getSignature(isDetailed) {
      if (_.isEmpty(this.getDataItem().name) || !isDetailed) {
        return this.getSignatureType();
      }

      var name = this.getDataItem().name;
      var lastIndexOfScopeDelimiter = name.lastIndexOf('.');
      var isScopedName = lastIndexOfScopeDelimiter !== undefined && lastIndexOfScopeDelimiter > 0;
      var shortName = isScopedName ? name.substr(lastIndexOfScopeDelimiter + 1) : name;
      var detailedSignature = "".concat(shortName, " ").concat(this._computeSignature(isDetailed));
      return detailedSignature;
    }
  }, {
    key: "_computeSignature",
    value: function _computeSignature(isDetailed) {
      // Compute signature for a single array element
      var elementDataItem = {
        type: this._elementType,
        name: ''
      };
      var elementComponents = this.getDataItem().components;

      if (elementComponents !== undefined) {
        elementDataItem.components = elementComponents;
      }

      var elementDataType = this.getFactory().create(elementDataItem);
      var elementSignature = elementDataType.getSignature(isDetailed); // Construct signature for array of type `element`

      if (this._arrayLength === undefined) {
        return "".concat(elementSignature, "[]");
      } else {
        return "".concat(elementSignature, "[").concat(this._arrayLength, "]");
      }
    }
  }], [{
    key: "matchType",
    value: function matchType(type) {
      return ArrayDataType._MATCHER.test(type);
    }
  }, {
    key: "_decodeElementTypeAndLengthFromType",
    value: function _decodeElementTypeAndLengthFromType(type) {
      var matches = ArrayDataType._MATCHER.exec(type);

      if (matches === null || matches.length !== 3) {
        throw new Error("Could not parse array: ".concat(type));
      } else if (matches[1] === undefined) {
        throw new Error("Could not parse array type: ".concat(type));
      } else if (matches[2] === undefined) {
        throw new Error("Could not parse array length: ".concat(type));
      }

      var arrayElementType = matches[1];
      var arrayLength = _.isEmpty(matches[2]) ? undefined : parseInt(matches[2], constants_1.constants.DEC_BASE);
      return [arrayElementType, arrayLength];
    }
  }]);

  return ArrayDataType;
}(set_1.AbstractSetDataType);

exports.ArrayDataType = ArrayDataType;
ArrayDataType._MATCHER = RegExp('^(.+)\\[([0-9]*)\\]$');